import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { AcuerdosService } from '../acuerdos.service';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { UserService } from '../user.service';

@Component({
  selector: 'app-editar-acuerdo',
  templateUrl: './editar-acuerdo.component.html',
  styleUrls: ['./editar-acuerdo.component.scss']
})
export class EditarAcuerdoComponent implements OnInit {

  proveedor_index : string = '';

  acuerdos: any[] = [];
  acuerdo_id : string = '-';

  msg: string = '';
  desglose: any[] = [];

  articulos:any[] = [];
  articulo = {
    'index' : '0',
    'nombre' : '',
    'unidades' : '',
    'aportacion' : ''
  };

  inicio: string = new Date().toISOString().slice(0, 10);
  dateTimeInicio: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.inicio = dateStr
  };

  limite: string = new Date().toISOString().slice(0, 10);
  dateTimeLimite: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.limite = dateStr
  };

  constructor(
    private rest: RestService,
    public user: UserService,
    public acuerdosService: AcuerdosService) {}

  ngOnInit() {}

  SeleccionarAcuerdo() {
    this.desglose = [];
    this.acuerdos = this.acuerdosService.acuerdos[this.proveedor_index].acuerdos;
    this.GetArticulosPorFamilia();
  }

  SeleccionarDesglose() {
    this.desglose = this.acuerdosService.acuerdos[this.proveedor_index].acuerdos[this.acuerdo_id].desglose;
  }

  ActualizarRegistro(d) {

    this.rest.ActualizarArticuloAcuerdo(d.id,d.aportacion,d.acuerdo_unidades_original)
    .subscribe(
      (data) => this.user.PublicMsg(data),
      (error) => this.user.PublicError(error) );
  }

  BorrarRegistro(d,index){
    this.rest.BorrarArticuloAcuerdo(d.id)
    .subscribe(
      (data) => {
        this.user.PublicMsg(data);
        this.desglose.splice(index, 1 );
      },
      (error) => this.user.PublicError(error) );
  }

  GetArticulosPorFamilia() {
    this.rest.getArticulosPorProveedor(this.acuerdosService.acuerdos[this.proveedor_index].idFamilia)
    .subscribe(
      (data) => {
        this.articulos = data['data'];
      },
      (error) => {
        this.user.PublicError(error);
        this.articulos = [];
      });
  }

  Guardar() {
    this.rest.CrearArticuloAcuerdo(
      this.articulos[this.articulo.index].IdPack,
      this.articulo.aportacion,
      this.articulo.unidades,
      this.acuerdosService.acuerdos[this.proveedor_index].acuerdos[this.acuerdo_id].id
      ).subscribe(
      (data) => {
        this.desglose.push({
          'Nombre' : this.articulos[this.articulo.index].Nombre,
          'aportacion' : this.articulo.aportacion,
          'acuerdo_unidades_original': this.articulo.unidades
        });
        this.user.PublicMsg(data);
      },
      (error) => {
        this.user.PublicError(error);
      });
  }

  EstablecerNuevasFechas() {

    this.rest.NuevasFechasAcuerdo(
      this.inicio,
      this.limite,
      this.acuerdosService.acuerdos[this.proveedor_index].acuerdos[this.acuerdo_id].id)
      .subscribe(
        (data) => {
          this.user.PublicMsg(data);
        },
        (error) => {
          this.user.PublicError(error);
        });
  }


}
